"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactResponsive = require("react-responsive");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../../utils");
var _Logo = require("../Logo");
var _excluded = ["height", "logoMobHeight"];
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var HeaderLogoMobile = (0, _styledComponents.default)(_Logo.Logo)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n"])), function (_ref) {
  var $height = _ref.$height;
  return $height || '26px';
});
var HeaderLogoDesktop = (0, _styledComponents.default)(_Logo.Logo)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", ";\n"])), function (_ref2) {
  var $height = _ref2.$height;
  return $height || '30px';
});
var Logo = function Logo(_ref3) {
  var height = _ref3.height,
    logoMobHeight = _ref3.logoMobHeight,
    props = _objectWithoutProperties(_ref3, _excluded);
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.sm
  });
  return isMobile ? /*#__PURE__*/_react.default.createElement(HeaderLogoMobile, _extends({}, props, {
    $height: logoMobHeight
  })) : /*#__PURE__*/_react.default.createElement(HeaderLogoDesktop, _extends({}, props, {
    $height: height
  }));
};
exports.Logo = Logo;